import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/Pageheader";
import Footer from "../Components/Footer";
import Sidebar from "../Components/Sidebar";
import { Link } from "react-router-dom";

function Profile() {
  return (
    <>
      <Header />
      <PageHeader pagename="my profile" />
      {/* Profile Section  */}
      <section className="profile-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">my info</h3>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="edit-profile-dv">
                     <Link to="/edit-profile">
                     <button className="btn-all" style={{ width: "32%" }}>
                        edit profile
                      </button>
                     </Link>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="info-border"></div>
                  </div>
                  <div className="col-md-4">
                    <div className="name-info">
                      <label className="primary-color">First Name :</label>
                      <p className="primary-color">Alexander</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="name-info">
                      <label className="primary-color">Last Name :</label>
                      <p className="primary-color">Volk</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="name-info">
                      <label className="primary-color">Email Address</label>
                      <p className="primary-color">John Williams@gmail.com</p>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="name-info">
                      <label className="primary-color">Password</label>
                      <p className="primary-color">
                        *********{" "}
                        <span className="change-password-span">
                          <Link to="/change-password" className="secondary-color">
                            Change Password
                          </Link>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="col-md-12 ">
                    <div className="name-info info-border">
                      <label className="primary-color">Address</label>
                      <p className="primary-color">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======================= */}
      <Footer />
    </>
  );
}

export default Profile;
